import React, { Component } from 'react';
import b from 'b_';

import Vacancies from '@components/vacancies';
import PageMeta from '@components/page-meta';
import Vacancy from '@interfaces/vacancy';
import { withAppData, AppDataProps } from 'client/contexts/app-data';

import './work-at-yandex.css';
import pageConfig from './page-config.json';

const class_ = b.with('work-at-yandex');

class WorkAtYandexPage extends Component<AppDataProps> {
    public shouldComponentUpdate() {
        return false;
    }

    public render() {
        const { description, noVacancies, tags, meta } = pageConfig;
        const { vacancies } = this.props.appData;

        const items: Vacancy[] = vacancies.map(vacancy => {
            vacancy.tags = vacancy.tags.map(tag => tags[tag.toLowerCase()] || tag);

            return vacancy;
        });

        return (
            <div className={class_()}>
                <PageMeta title={meta.title} description={meta.description} />

                <div className={class_('content')}>
                    <h1 className="block__title">Work at Yandex Research</h1>
                    <div className={class_('description')}>
                        {description}
                    </div>
                    {items.length > 0
                        ? (
                            <div className={class_('vacancies')}>
                                <Vacancies vacancies={items} />
                            </div>
                        )
                        : (
                            <div className={class_('no-vacancies')}>
                                {noVacancies}
                            </div>
                        )
                    }
                </div>
            </div>
        );
    }
}

export default withAppData(WorkAtYandexPage);
